import _ from "lodash";
import { ITreeNode } from "./TreeNode";

const TABLE = "dirs"

export type TTreeNodeToggleHandler<T> = (node:ITreeNode<T>, expanded:boolean) => void
export interface ITreeNodeFinder<T> {
    findNode: (id:string) => ITreeNode<T>|null
}
export default class TreeNodeSession<T> {
    private _table:string
    private _finder:ITreeNodeFinder<T>
    private _expanded:string[]

    constructor(finder:ITreeNodeFinder<T>, tableName:string=TABLE) {
        this._table = tableName
        this._finder = finder
        try {
            const ids = this._expanded = JSON.parse(localStorage.getItem(TABLE) || "[]")
            for(const id of ids) {
                const node = this._finder.findNode(id)
                if (node) node.expanded = true
            }
        }catch(e){
            this._expanded = []
        }
    }

    open(id:string, finder:ITreeNodeFinder<T>){
        if (!this._expanded.includes(id)) this._expanded.push(id)
        const row = finder.findNode(id)
        if (!row) return this
        row.expanded = true
        if (row.parent) this.open(row.parentId!, finder)
        return this
    }

    toggle(node:ITreeNode<T>){
        if (node.expanded && !this._expanded.includes(node._id)) {
            this._expanded.push(node._id)
            this.save()
        }
        else if (!node.expanded && this._expanded.includes(node._id)) {
            _.pull(this._expanded, node._id)
            this.save()
        }
    }

    save(){
        localStorage.setItem(this._table, JSON.stringify(this._expanded))
        return this
    }
}